@if (shouldRender()) {
<section class="block-top-sellers">
  <div class="block-top-sellers__inner">
    <app-product-carousel
      title="Más vendidos"
      viewAllLink="/tienda"
      [viewAllQueryParams]="{ sort: 'popular' }"
      [products]="products()"
      [arrowsOnHover]="true"
      [showPagination]="true"
      (addToCart)="addToCart.emit($event)"
      (zoomOpen)="zoomOpen.emit($event)"
      (notifyRequest)="notifyRequest.emit($event)"
      (notifyCancel)="notifyCancel.emit($event)"
      (cardClick)="cardClick.emit($event)"
      (reserveClick)="reserveClick.emit($event)"
    />
  </div>
</section>
}
